import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { moment } from 'util/dateTime';

import Note from '../../NoteSection/Note';

const { cx, cxEl } = cxHelpers('Notes');

const MAX_DISPLAY = 3;

const Notes = ({ notes, type, feedback, employeeName }) => {
  switch (type) {
    case 'manager_notes': {
      return (
        <Box className={cx()} column>
          {notes
            .slice(0, MAX_DISPLAY)
            .map(
              note =>
                !note.get('event_type') &&
                note.get('body') && (
                  <Note
                    note={note}
                    key={note.get('id')}
                    className={cxEl('manager_note')}
                    eventType={note.get('event_type')}
                    noteBody={note.get('body')}
                    date={moment(note.get('created_at'))}
                  />
                )
            )}
        </Box>
      );
    }
    case 'break_notes': {
      return (
        <Box className={cx()} pv={4} column>
          {notes.slice(0, MAX_DISPLAY).map(note => (
            <Note
              note={note}
              key={note.get('id')}
              className={cxEl('break_note')}
              eventType={note.get('event_type')}
              noteBody={note.get('message')}
              date={moment(note.get('created_at'))}
            />
          ))}
        </Box>
      );
    }
    case 'worked_notes': {
      return (
        <Box className={cx()} pv={4} column>
          {notes.slice(0, MAX_DISPLAY).map(note => (
            <Note
              note={note}
              key={note.get('id')}
              className={cxEl('worked_note')}
              eventType={note.get('event_type')}
              noteBody={note.get('message')}
              date={moment(note.get('created_at'))}
            />
          ))}
        </Box>
      );
    }
    case 'tips_notes': {
      return (
        <Box className={cx()} pv={4} column>
          {notes.slice(0, MAX_DISPLAY).map(note => (
            <Note
              note={note}
              key={note.get('id')}
              className={cxEl('tip_note')}
              eventType={note.get('event_type')}
              noteBody={note.get('message')}
              date={moment(note.get('created_at'))}
            />
          ))}
        </Box>
      );
    }
    case 'feedback': {
      return (
        <Box className={cx()} pv={4} column>
          <Note
            className={cxEl('feedback')}
            employeeName={employeeName}
            body={feedback.get('body')}
            rating={feedback.get('rating')}
            title={feedback.get('title')}
          />
        </Box>
      );
    }
    default:
      return null;
  }
};

Notes.propTypes = {
  notes: PropTypes.object,
  type: PropTypes.string.isRequired,
  feedback: PropTypes.object,
  employeeName: PropTypes.string,
};

export default Notes;
